/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Notes_PlaceholderInputs */

const en_directory_submit_notes_placeholder = /** @type {(inputs: Directory_Submit_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing details, your relationship to the tool, anything else we should know.`)
};

const zh_directory_submit_notes_placeholder = /** @type {(inputs: Directory_Submit_Notes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定价细节、你与该工具的关系、或其他我们需要了解的信息。`)
};

/**
* | output |
* | --- |
* | "Pricing details, your relationship to the tool, anything else we should know." |
*
* @param {Directory_Submit_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_notes_placeholder = /** @type {((inputs?: Directory_Submit_Notes_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Notes_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_notes_placeholder(inputs)
	return zh_directory_submit_notes_placeholder(inputs)
});
export { directory_submit_notes_placeholder as "directory.submit.notes_placeholder" }